export default __webpack_public_path__ + "b2681e5559255488319a7a9e1f547653.png";